/* istanbul ignore file */
export { default } from './NavBarContactDetails';
